import api from "./axiosInstance";
import { v4 as uuidv4 } from 'uuid'; // Для генерации GUID

export const BasketAPI = {
  getAnonymousId(): string {
    let anonymousId = localStorage.getItem('anonymousId');
    if (!anonymousId) {
      anonymousId = uuidv4();
      localStorage.setItem('anonymousId', anonymousId);
    }
    return anonymousId;
  },

  async getItems() {
    const token = localStorage.getItem('token');
    if (token) {
      // Если есть токен, делаем авторизованный запрос
      // Позволяем axios interceptor'у обработать 401 ошибки
      const response = await api.get('basket');
      return response.data;
    } else {
      // Если токена нет, делаем анонимный запрос
      const anonymousId = this.getAnonymousId();
      const response = await api.get(`basket/${anonymousId}`);
      return response.data;
    }
  },

  async addItem(partUniqueId: string, price: PriceDetails) {
    const token = localStorage.getItem('token');
    if (token) {
      // Если есть токен, делаем авторизованный запрос
      // Позволяем axios interceptor'у обработать 401 ошибки
      const response = await api.post(`basket?partUniqueId=${partUniqueId}`, price);
      return response.data;
    } else {
      // Если токена нет, делаем анонимный запрос
      const anonymousId = this.getAnonymousId();
      const response = await api.post(`basket/anonymous/${anonymousId}?partUniqueId=${partUniqueId}`, price);
      return response.data;
    }
  },

  async updateItem(itemId: number, count: number) {
    const token = localStorage.getItem('token');
    if (token) {
      // Если есть токен, делаем авторизованный запрос
      // Позволяем axios interceptor'у обработать 401 ошибки
      const response = await api.patch(`basket?itemId=${itemId}&count=${count}`);
      return response.data;
    } else {
      // Если токена нет, делаем анонимный запрос
      const anonymousId = this.getAnonymousId();
      const response = await api.patch(`basket/anonymous/${anonymousId}?itemId=${itemId}&count=${count}`);
      return response.data;
    }
  },

  async deleteItem(itemId: number) {
    const token = localStorage.getItem('token');
    if (token) {
      // Если есть токен, делаем авторизованный запрос
      // Позволяем axios interceptor'у обработать 401 ошибки
      const response = await api.delete(`basket?itemId=${itemId}`);
      return response.data;
    } else {
      // Если токена нет, делаем анонимный запрос
      const anonymousId = this.getAnonymousId();
      const response = await api.delete(`basket/anonymous/${anonymousId}?itemId=${itemId}`);
      return response.data;
    }
  },

  async addTyreItem(tyreId: number, quantity: number = 1) {
    const token = localStorage.getItem('token');
    if (token) {
      // Если есть токен, делаем авторизованный запрос
      // Позволяем axios interceptor'у обработать 401 ошибки
      const response = await api.post(`basket/tyre?tyreId=${tyreId}&quantity=${quantity}`);
      return response.data;
    } else {
      // Если токена нет, делаем анонимный запрос
      const anonymousId = this.getAnonymousId();
      const response = await api.post(`basket/anonymous/${anonymousId}/tyre?tyreId=${tyreId}&quantity=${quantity}`);
      return response.data;
    }
  }
};

interface PriceDetails {
  value: number;
  available: number;
  deliveryDate: string;
  providerType: ProviderType;
  providerOrderInfo?: string;
  temporaryPriceGuid?: string;
}

enum ProviderType {
  None = 0,
  Shate = 1,
  Rossko = 2,
}